import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <>
      <Header />
      <main id="content" className="site-main">
        {/* Inner Banner html start*/}
        <section className="inner-banner-wrap">
          <div
            className="inner-baner-container"
            style={{
              backgroundImage:
                "url(https://res.cloudinary.com/dvop4v8kb/image/upload/c_fill,e_improve,w_1920,h_900/v1687861594/mika-baumeister-PZao9UjlbMY-unsplash_ersusg.jpg)"
            }}
          >
            <div className="container">
              <div className="inner-banner-content">
                <h1 className="inner-title">Booking</h1>
              </div>
            </div>
          </div>
          <div className="inner-shape" />
        </section>
        {/* Inner Banner html end*/}
        <div className="step-section cart-section">
          <div className="container">
           
            {/* step three form html start */}
            <div className="confirmation-outer">
              <div className="success-notify">
                <div className="success-icon">
                  <i className="fas fa-check" />
                </div>
                <div className="success-content">
                  <h3>PAYMENT CONFIRMED</h3>
                  <p>
                    Thank you, your payment has been successful and your booking
                    is now confirmed.A confirmation email has been sent to your email.
                  </p>
                </div>
              </div>
              <div className="backbutton">  
              <Link to="/" className="btn btn-primary button-primary">
              Back To Home
             </Link>
                </div>
            </div>
            {/* step three form html end */}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
